import { useIServiceDivision as useIServiceDivisionApi } from '@/hooks/api/useIServiceApi';

// 缓存请求中的 Promise，避免重复调用
let divisionPromise = null;

export const useGetDivision = async (currentActionState) => {
  let division = currentActionState?.customGlobal?.division;
  if (!division) {
    // 如果已有请求在进行中，直接复用该 Promise
    if (!divisionPromise) {
      divisionPromise = useIServiceDivisionApi(true).then(({ data }) => data.value);
    }
    division = await divisionPromise;
    if (currentActionState?.customGlobal) {
      currentActionState.customGlobal.division = division;
    }
  }
  return division;
};
